import { Layout } from "../../ui/layout";
import { MenuItems } from "../../ui/organisms/navbar/dto";

export function Dashboard() {
    return (
        <Layout menuItem={MenuItems.DASHBOARD} breadcrumbItems={['Dashboard']} headerLabel="Dashboard">
        </Layout>
    );
}
